import { Grid, Typography, Box, Switch, FormControlLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomButton from "../../../components/common/button/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getCommunincationAction,
  setUpdateCommunicationResponse,
  updateCommunicationAction,
} from "../../../store/reducers/settingSlice";

const LeadEmailAutomation = () => {
  const dispatch = useDispatch();
  const { leadEmailCommunication,isUpdateLeadEmailCommunicationResponse } = useSelector((state: any) => state.setting);

  const [emailAutomation, setEmailAutomation] = useState({
    manual_lead_email: false,
    import_lead_email: false,
  });

  /* ---------------- GET SETTINGS API ---------------- */
  useEffect(() => {
    dispatch(getCommunincationAction());
  }, [dispatch]);

  /* ---------------- SET STATE FROM REDUX ---------------- */
  useEffect(() => {
    if (leadEmailCommunication) {
      setEmailAutomation({
        manual_lead_email: leadEmailCommunication?.manual_lead_email ?? false,
        import_lead_email: leadEmailCommunication?.import_lead_email ?? false,
      });
    }
  }, [leadEmailCommunication]);

  useEffect(()=>{
    if(isUpdateLeadEmailCommunicationResponse){
        dispatch(getCommunincationAction());
        dispatch(setUpdateCommunicationResponse(false));
    }
  },[isUpdateLeadEmailCommunicationResponse])

  /* ---------------- TOGGLE CHANGE ---------------- */
  const handleToggleChange = (event: any) => {
    const { name, checked } = event.target;

    setEmailAutomation((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  /* ---------------- SAVE ---------------- */
  const handleSubmit = () => {
    dispatch(updateCommunicationAction(emailAutomation));
  };

  return (
    <section style={{ marginTop: "20px" ,background:'#fff',padding:'10px 16px' }}>
      <Typography variant="h5" fontWeight={700}>
        Lead Email Automation
      </Typography>

      <Typography sx={{ mb: 2, color: "#637381" }}>
        Enable or disable automatic email notifications when a new lead is created.
      </Typography>

      <Grid
        container
        spacing={2}
        sx={{
          padding: "16px",
          mt: 1,
          background: "#E5F4F1",
          borderRadius: "5px",
        }}
      >
        {/* Manual Lead Toggle */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              background: "#fff",
              border: "1px solid #dcdcdc",
              borderRadius: "5px",
              padding: "12px 16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography fontWeight={600}>Manual Lead Creation</Typography>

            <FormControlLabel
              control={
                <Switch
                  checked={emailAutomation.manual_lead_email}
                  onChange={handleToggleChange}
                  name="manual_lead_email"
                />
              }
              label=""
            />
          </Box>
        </Grid>

        {/* Import Lead Toggle */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              background: "#fff",
              border: "1px solid #dcdcdc",
              borderRadius: "5px",
              padding: "12px 16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography fontWeight={600}>Imported Leads</Typography>

            <FormControlLabel
              control={
                <Switch
                  checked={emailAutomation.import_lead_email}
                  onChange={handleToggleChange}
                  name="import_lead_email"
                />
              }
              label=""
            />
          </Box>
        </Grid>

        {/* Save Button */}
        <Grid
          item
          md={12}
          xs={12}
          display="flex"
          justifyContent="flex-end"
          mt={2}
        >
          <CustomButton
            style={{ width: "120px" }}
            title="Save"
            onClick={handleSubmit}
          />
        </Grid>
      </Grid>
    </section>
  );
};

export default LeadEmailAutomation;